/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RelatedEntityAdjustment } from './RelatedEntityAdjustment';
export type WaterfallParameters = {
  exit_date: string;
  exit_equity_value: string;
  exit_enterprise_value?: string;
  plus_cash?: string;
  less_debt?: string;
  foreign_currency?: string;
  /**
   * Units of the selected currency per unit of cap-table currency.
   */
  foreign_exchange_rate?: string;
  currency_format?: WaterfallParameters.currency_format;
  related_entity_adjustments?: Record<string, RelatedEntityAdjustment>;
};
export namespace WaterfallParameters {
  export enum currency_format {
    REGULAR = 'regular',
    THOUSANDS = 'thousands',
    MILLIONS = 'millions',
  }
}

